import { render, staticRenderFns } from "./ApprovePaymentBulkOperationPage.vue?vue&type=template&id=51779768&"
import script from "./ApprovePaymentBulkOperationPage.vue?vue&type=script&lang=js&"
export * from "./ApprovePaymentBulkOperationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports